<template>
    <div class="lg-grid">
        <div class="flex-row">
            <div class="flex-col col1">
                <div class="elem1">
                    <div class="flex-col">
                        <slot name="Profession"/>
                    </div>
                </div>
                <div class="flex-row">
                    <div class="flex-col elem2">
                        <slot name="Bucket"/>
                    </div>
                </div>
            </div>
            <div class="flex-col col2">
                <div class="flex-row">
                    <div class="flex-col elem3">
                        <slot name="Timeline"/>
                        <slot name="Competences"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LGGrid',
};
</script>

<style lang="scss" scoped>
    @import '~@/styles/rem';
    .lg-grid{
        padding: 32px;
        display: block;
        max-width: 1920px;
        margin: 0 auto;
        .flex-row{
            display: flex;
            flex-direction: row;
            align-items: stretch;
            width: 100%;
            flex: 1;

            .col1{
                flex: 1;
                max-width: 598px;
                min-width: 480px;
                height: auto;
            }
            .col2{
                flex: 2;
            }
        }
        .flex-col{
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            flex: 1;
        }
    }
    .elem1 {
        margin-bottom: 32px;
    }
    .elem3{
        margin-left: 32px;
    }
</style>
